export default {
  locale: 'en',
  messages: {
    //Login pages
    switchLanguage: 'Switch Language',
    loginHeader: 'Sign In',
    email: 'Business email',
    name: 'Name',
    password: 'Password',
    newPassword: 'New password',
    loginBtn: 'Sign in',
    logoutBtn: 'Logout',
    regSubmitBtn: 'Get started',
    createAcc: 'Create an account',
    signUpFree: 'Sign up for free',
    forgotPass: 'Forgot your password?',
    resendPassRequest: 'Please resend your account activation email',
    resendPassRequest2: 'receive a new one?',
    recoverPass: 'recover your password',
    signinExisting: 'Sign in to your existing account',
    passwordTooltip: 'Please ensure your password is at least 8 characters long',
    regLink: 'Need a Nave account? {link}',
    signInLink: 'Already usign Nave? {link}',
    resetHeader:
      '<h2>Forgot your password?</h2> No problem! Enter your email here and we\'ll send you a link to reset it. If you are still having trouble, <a href="mailto:sonya@nave.be">get in touch with us</a> and we\'ll take care of it',
    resetPasswordHeader: '<h2>Reset your password?</h2> Please enter your new password',
    resetBtn: 'Reset my password',
    thankYou: 'Thank you!',
    resetSubmitted: 'We sent you an email with instructions on how to reset your password',
    resetCompleted: 'Your password has been successfully changed',
    resetToLogin: 'Back to Sign in',
    termsOfUse:
      'By clicking this button, you agree to Nave\'s <a target="_blank" href="/terms">terms of services</a> and <a target="_blank" href="/policy">privacy policy</a>',

    //Billing form
    addCard: 'Add card',
    fullName: 'Full name',
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    city: 'City',
    zip: 'ZIP',
    country: 'Country',

    //CFD
    cfd: 'Cumulative Flow Diagram',

    //Cycle time scatter plot
    ctsp: 'Cycle Time Scatterplot',

    //Cycle time breakdown
    ctb: 'Cycle Time Breakdown Chart',

    //Cycle time histogram
    cth: 'Cycle Time Histogram',

    //Cycle time aging
    cta: 'Aging Chart',

    //Throughput
    throughput: 'Throughput Run Chart',

    //Throughput histogram
    throughputHistogram: 'Throughput Histogram',
    flowEfficiency: 'Flow Efficiency Chart',
    monteCarloDate: 'Monte Carlo: Delivery Date',
    monteCarloTasks: 'Monte Carlo: Number of Tasks',
    continuesForecasting: 'Continuous Forecasting',
    dueDatePerf: 'Due Date Performance Chart',
    flowMetricsAndAnalytics: 'Flow Metrics & Analytics',
    processImprovement: 'Process Improvement',

    // reports
    exec_rep: 'Value Streams',
    comp_rep: 'Portfolios',

    //Error codes
    not_used:
      'We couldn\'t find an account with that email address. Please retry or <br /> <a href="/register">Sign up for free</a>',
    401: 'Incorrect token',
    402: 'Your account is not active yet. Can we suggest to resend your account activation email?',
    404: 'We couldn\'t find an account with that email address. Please retry or <a href="/register">Sign up for free</a>',
    410: 'Another user with this email already exists. Please try with a different email address, or <a href="/login">Sign in to your existing account</a>',
    411: "You didn't enter an email address",
    412: "You didn't enter your name",
    413: 'It looks like you forgot to populate your password',
    414: "It looks like your password doesn't meet the requirements. It must be at least 8 characters long",
    415: '',
    416: 'Your password reset link has expired. Would you like to <a href="/forgot-password">receive a new one?<a/>',
    417.1: `For security reasons, after {loginAttempts} more failed login attempts you'll have to wait 30 minutes before trying again`,
    417: `For security reasons, you'll have to wait {tryIn} minutes before trying again`,
    418: 'Your verification link is not valid anymore. <a href="javascript:void(0)">Please resend your account activation email</a>',
    419: 'Account already activated',
    420: 'It looks like that is not a valid email',
    500: 'Something went wrong. We weren\'t able to sign you up. Please try again or <a href="mailto:sonya@nave.be">contact us</a>',

    dashboard: 'Team overview',
    pricing: 'Pricing',
    billing: 'Billing',
    upgrade: 'Upgrade',
    taskDashboard: 'Tasks',
    calendarEvent: 'Calendar',
    profile: 'Profile',
    changePassword: 'Change password',
    billingInformation: 'Billing Information',
    seat: 'seat',

    //Validation errors
    'error.user.nobilling': 'Billing account not found',
    'error.user.alreadyinvited': 'User has already been invited',
    'error.user.allusersinvited': 'This user has already been invited',
    'error.user.someusersinvited': 'Some users have already been invited',
    'error.dashboard.notfound': 'Dashboard does not exists',
    'error.dashboard.required': 'Dashboard ID is required',
    'error.dashboardview.existingname': 'Dashboard view with this name already exists',
    'error.dashboard.notfoundorremoved': 'Dashboard {dashboardId} not found or already removed',
    'error.dashboard.boarddeleted':
      'Board associated with this dashboard was deleted. Please delete and recreate the dashboard again',
    'error.dashboard.inprogress':
      'Your dashboard is currently synchronizing your data, please give it a few moments until it is finished',
    'error.name.any.empty': 'Enter dashboard name',
    'error.email.any.required': 'Enter email address',
    'error.email.array.invalid': 'You have specified invalid email',
    'error.email.invalid': 'Enter email address',
    'error.email.array.includesRequiredUnknowns': 'Enter email addresses',
    'error.username.any.required': 'Select user',
    'error.board.nopermissions': "You don't have permissions to this board",
    'error.board.notfound':
      'The requested board cannot be viewed because it either does not exist or you do not have permission to view it',
    'error.board.noproject': 'The requested board does not have associated project',
    'error.boardId.any.required': 'You have to select a board from the list with your boards',
    'error.dashboardId.any.required': 'Dashboard ID is required',
    'error.todo.array.min': "Drag and drop your lists with tasks that haven't started yet into the To Do column",
    'error.wip.array.min': 'Drag and drop your lists with tasks in progress into the Doing column',
    'error.done.array.min': 'Drag and drop your lists with completed tasks into the Done column',
    'error.billing.zip': 'Incorrect ZIP code',
    'error.selectedDashboards.array.min': 'Select at least one dashboard',
    'error.name.string.alphanum': 'Invalid characters',

    'error.name.empty': 'Please enter your name',
    'error.email.empty': 'Please enter your email address',
    'error.email.any.empty': 'Please enter your email address',
    'error.email.string.email': 'There might be a typo in your email address',
    'error.password.empty': 'Please enter your password',
    'error.password.string.min': 'You need a stronger password that’s longer than 8 symbols',
    'error.password.string.max':
      'It’s great you’re taking online security seriously, but your password needs shorter than 99 symbols',
    'error.oldPassword.any.required': 'Please enter your old password',
    'error.oldPassword.invalid': 'Old password seems to be incorrect',
    'error.newPassword.any.required': 'Please enter your new password',
    'error.newPassword.string.min': 'You need a stronger password that’s longer than 8 symbols',
    'error.newPassword.string.max':
      'It’s great you’re taking online security seriously, but your password needs shorter than 99 symbols',
    'error.user.notfound': 'We don’t have you on file. Are you sure you’ve signed up with this email address?',
    'error.user.invalid': 'Email address or password seems to be incorrect',
    'error.user.emailExists': 'An existing user is already using that email address',
    'error.token.notactivated':
      'Your account hasn’t been made active yet. Please confirm your email address in order to continue',
    'error.token.invalid': 'Your token is incorrect',
    'error.token.expired': 'Provided token is incorrect or has been expired',
    'error.dashboard.name': 'Enter dashboard name',
    'error.area.notfound': 'Area Path is required',
    'error.customfields.required': 'At least one custom field should be selected',

    'error.account.subscriptionawaiting': 'Pending subscription activation',
    'error.account.notfound': 'User not linked to an account',
    'error.account.notowner': 'Permission denied',
    'error.account.nobillingemail': 'Billing email is required',
    'error.account.invalidbillingemail': 'Invalid billing emails',
    'error.plan.noplan': 'We are not able to load the plans right now. Please try again later',
    'error.payment.nonce': 'Missing nonnce',
    'error.billing.vat_number': 'Invalid VAT number',
    'error.payment.invalid_coupon': 'Invalid coupon',
    'error.account.quotaReached': "You're all out of dashboards! Please upgrade your plan to add a new one.",

    'error.file.notobject':
      'This file format is not supported. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid':
      'This file format is not supported. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.id':
      'This file does not contain an ID column. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.missingid':
      'This file contains an item without value in the ID column. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.name':
      'This file does not contain a Name column. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.invalidblocked':
      'This file contains an invalid Blocked Date Range. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.noblocked':
      'This file does not contain a Blocked Date Range column. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.workflow':
      'This file should have at least three workflow states. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.file.invalid.workflowFormat':
      'This file contains dates in an incorrect format. Please follow our guidelines on <a class="link" target="_blank" href="https://getnave.com/blog/loading-data-to-nave">how to load your data to Nave.</a>',
    'error.totalItems.number.less': 'Maximum number of items is 1000',
    'error.board.not.found': 'Board not found',
    'error.no.root.node': 'Root areapath not found',

    'success.user.registered': 'You will receive registration confirmation on your email.',
    'success.auth.forgotPasswordSent': 'We’ve emailed your new password. Please check your inbox.',
    'success.auth.passwordSuccesfullyReset': 'Password successfully reset',
    'success.auth.passwordSuccesfullyChanged': 'Password successfully changed',
    'success.file.uploading': 'File uploading',
    'success.request.requestSent':
      "We've notified your account managers! Once your request is approved, you'll be able to access your corporate account.",
    'success.request.joined': 'You can access your corporate account now!',

    'user-not-found-short': 'User not found',
    'no-access-short': 'No access',
    'board-not-found-short': 'Board not found',
    'no-default-project-short': 'No default project',
    'areapath-not-found-short': 'Areapath not found',
    'no-root-node-short': 'Root areapath not found',
    'no-items': 'No items were found for the current dashboard configuration',
    'no-items-short': 'No items found',
    'cf-endpoint-error-short': 'Endpoint error',

    // tenant
    'error.name.string.regex.base': 'Incorrect characters, please use only latin characters and dashes',
    'error.name.string.max': 'Maximum allowed characters count is 30',
    'error.name.string.min': 'Minimum characters count is 4',
    'error.name.any.invalid': 'Name is already reserved. Please provide alternative name',
    'error.name.any.forbidden': 'You have already joined organization tenant',
    'error.token.string.regex.base': 'Invalid token',

    'not-authenticated':
      'The user who created your dashboard is no longer authenticated and your data is NOT up to date. Please <a class="link" href="/api/dashboards/{DASHBOARD_ID}/refetch">click here</a> to resync your data.',
    'user-not-found':
      'The user who created your dashboard is no longer available on your account and your data is NOT up to date. Please <a class="link" href="/api/dashboards/{DASHBOARD_ID}/refetch">click here</a> to resync your data.',
    'no-access':
      'The user who created your dashboard no longer has access to the data in your management platform and your dashboard is NOT up to date. Please <a class="link" href="/api/dashboards/{DASHBOARD_ID}/refetch">click here</a> to resync your data.',
    'board-not-found':
      "The board in your management platform doesn't exist any more and your data is NOT up to date. You may delete this dashboard.",
    'areapath-not-found':
      'The area path you have selected is no longer available in your Azure DevOps project and your dashboard is NOT up to date. Please choose Gear icon > Edit dashboard and select a new area path to resolve the problem.',
    'no-root-node':
      'The root node of the area path you have selected is no longer available in your Azure DevOps project and your dashboard is NOT up to date. You may delete this dashboard.',
    'no-default-project':
      'Oops, we weren\'t able to synchronize your custom fields. To resolve the problem, please navigate to your board in Jira, choose Gear icon > Board settings, under General, select the Location field and type the name of your default project. Then, <a class="link" href="/api/dashboards/{DASHBOARD_ID}/refetch">click here</a> to resync your data.',
    'cf-endpoint-error':
      'Oops, we weren\'t able to synchronize your custom fields. Please check for any current outages in your management system. Once the problem is resolved, <a class="link" href="/api/dashboards/{DASHBOARD_ID}/refetch">click here</a> to resync your data.',

    trello: {
      appname: 'Trello',
      organisation: 'organisation',
      loginBoard: 'board',
      board: 'board',
      list: 'list',
      label: 'label',
      member: 'member',
      card: 'card',
      'no-label': 'Cards without labels',
      'no-member': 'Cards without members',
      'no-option': '(no option)'
    },
    asana: {
      appname: 'Asana',
      organisation: 'team',
      loginBoard: 'project',
      board: 'project',
      list: 'section',
      label: 'tag',
      member: 'user',
      card: 'task',
      'no-label': 'Tasks without tags',
      'no-member': 'Tasks without users',
      'no-option': '(no option)'
    },
    jira: {
      appname: 'Jira',
      organisation: 'project',
      loginBoard: 'project',
      board: 'board',
      list: 'status',
      label: 'priority',
      member: 'assignee',
      card: 'work item',
      'no-label': 'Work items without priorities',
      'no-member': 'Work items without assignees',
      'no-option': '(no option)'
    },
    azure: {
      appname: 'Azure DevOps',
      organisation: 'project',
      loginBoard: 'board',
      board: 'board',
      list: 'column',
      label: 'work item type',
      member: 'assignee',
      card: 'item',
      'no-label': 'Items without tags',
      'no-member': 'Items without assignees',
      'no-option': '(no option)',
      errors: {
        incorrectHost: 'Incorrect Azure DevOps host'
      }
    },
    file: {
      appname: 'File',
      organisation: 'project',
      loginBoard: 'project',
      board: 'board',
      list: 'status',
      label: 'priority',
      member: 'assignee',
      card: 'work item',
      'no-label': 'Work items without priorities',
      'no-member': 'Work items without assignees',
      'no-option': '(no option)'
    }
  }
};
